// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MsftDefenderIcon = createSvgIcon(
  <svg viewBox="0 0 48 48">
    <path fill="#0370c8" d="M24 44a1 1 0 0 1 0-2z" />
    <path fill="#0f5094" d="M25 43a1 1 0 0 1-1 1v-2a1 1 0 0 1 1 1" />
    <circle cx={42} cy={11} r={1} fill="#0883d9" />
    <circle cx={6} cy={11} r={1} fill="#33bff0" />
    <path fill="#0f5094" d="m24 43 .43.9S39.57 36 42.5 24H24z" />
    <path
      fill="#0883d9"
      d="m43 11-1-1c-11.12 0-11.28-6-18-6v20h18.5q.49-1.93.5-4z"
    />
    <path fill="#0370c8" d="m24 43-.43.9S8.43 36 5.5 24H24z" />
    <path
      fill="#33bff0"
      d="m5 11 1-1c11.12 0 11.28-6 18-6v20H5.5Q5 22.07 5 20z"
    />
  </svg>,
  "MsftDefender",
);
export default MsftDefenderIcon;
